import React from 'react';
import PropTypes from 'prop-types';
import {Container} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import {useStyles} from './AffiliateBannerStyles';
import {withNamespaces} from 'react-i18next';
import clsx from 'clsx';

function AffiliateBanner({
	t,
	classes,
	planConfig
}) {
	return (
		<div className={clsx(classes.affiliateBanner, {[classes[planConfig?.affiliateBannerBgClassName]]: planConfig?.affiliateBannerBgClassName})}>
			<Container component="div" className={classes.affiliateBannerContainer}>
				<span className={classes.affiliateBannerText}>{t(planConfig?.affiliateBannerText)}</span>
				<img src={planConfig?.affiliateBannerLogo} alt="" width={planConfig?.affiliateBannerLogoWidth || 239} height={planConfig?.affiliateBannerLogoHeight || 38} className={classes.affiliateBannerLogo}/>
			</Container>
		</div>
	);
}

AffiliateBanner.propTypes = {
	classes: PropTypes.object,
	planConfig: PropTypes.object,
	t: PropTypes.func
};

export default withStyles(useStyles)(withNamespaces()(AffiliateBanner));